<template>
    <div>
        <div v-if="errors.length" style="background-color: #cd1733; color: #fff; text-transform: uppercase; border-radius: 10px; padding: 8px 0; text-align: center; font-weight: bold; margin-top: 15px;">
            <ul style="margin: 0; padding: 0; list-style: none;">
                <li v-for="error in errors"><i class="fas fa-exclamation-circle"></i> {{ error }}</li>
            </ul>
        </div>
        <div class="container my-3">
            <div v-if="!completed">
                <div class="row justify-content-md-center">
                    <div class="col-md-12">
                        <ul class="progressbar">
                            <li v-bind:class="{ active: currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5 || currentStep === 6 || currentStep === 7 || currentStep === 8 || currentStep === 9 || currentStep === 10 || currentStep === 11 || currentStep === 12 }">Valoració Elements</li>
                            <li v-bind:class="{ active: currentStep === 8 || currentStep === 9 || currentStep === 10 || currentStep === 11 || currentStep === 12 }">Ordenació Elements</li>
                            <li v-bind:class="{ active: currentStep === 9 || currentStep === 10 || currentStep === 11 || currentStep === 12 }">Preguntes Obertes</li>
                        </ul>
                    </div>
                    <div v-show="currentStep === 1" class="col-md-9 text-center">
                        <img :src="'../img/escut/escudo.jpg'" class="mt-5" style="width: 300px;" alt="">
                        <h3 class="my-3 font-weight-bold">Com funciona la consulta?</h3>
                        <p class="text-max-800 font-weight-bold">La consulta consta de 3 grans apartats:</p>
                        <p class="text-max-800 mt-2"><span class="font-weight-bold">1. Valora els elements</span> que conformen l'escut de l'1 al 10, sent l'1 l'expressió de la mínima satisfacció i el 10 la màxima.</p>
                        <p class="text-max-800 mt-2"><span class="font-weight-bold">2. Ordena els elements</span> de més a menys importants egons el teu punt de vista.</p>
                        <p class="text-max-800 mt-2"><span class="font-weight-bold">3. Respon les preguntes</span> que et formulem.</p>
                        <p class="text-max-800 mt-2">El club recollirà les respostes de tots els Socis, que servirà com a guia per a dissenyar el nou escut.</p>
                    </div>
                    <div v-show="currentStep === 2" class="col-md-9 text-center">
                        <img :src="'../img/escut/corona.jpg'" class="my-5" style="width: 300px;" alt="">
                        <h3 class="my-3 font-weight-bold">CORONA</h3>
                        <p class="text-max-800">La corona ve donada per l’escut de la ciutat. S'utilitza la corona ducal perquè aquest era el tipus de corona que timbrava l’escut de la ciutat durant la fundació, al 1930. En heràldica la ubicació actual de la corona és incorrecte, doncs no timbra l’escut de la ciutat sinó l’escut del Club.</p>
                        <div class="custom-radios">
                            <div>
                                <input type="radio" id="corona-1" v-model="form.corona" value="1">
                                <label for="corona-1">
                                    <span>1</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-2" v-model="form.corona" value="2">
                                <label for="corona-2">
                                    <span>2</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-3" v-model="form.corona" value="3">
                                <label for="corona-3">
                                    <span>3</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-4" v-model="form.corona" value="4">
                                <label for="corona-4">
                                    <span>4</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-5" v-model="form.corona" value="5">
                                <label for="corona-5">
                                    <span>5</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-6" v-model="form.corona" value="6">
                                <label for="corona-6">
                                    <span>6</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-7" v-model="form.corona" value="7">
                                <label for="corona-7">
                                    <span>7</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-8" v-model="form.corona" value="8">
                                <label for="corona-8">
                                    <span>8</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-9" v-model="form.corona" value="9">
                                <label for="corona-9">
                                    <span>9</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="corona-10" v-model="form.corona" value="10">
                                <label for="corona-10">
                                    <span>10</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-show="currentStep === 3" class="col-md-9 text-center">
                        <img :src="'../img/escut/senyera.jpg'" class="my-5" style="width: 300px;" alt="">
                        <h3 class="my-3 font-weight-bold">SENYERA</h3>
                        <p class="text-max-800">Bandera de Catalunya. La forma d’escut caironat (rombe recolzat sobre un dels seus angles) ve donada per l’escut de la ciutat de Girona.</p>
                        <div class="custom-radios">
                            <div>
                                <input type="radio" id="senyera-1" v-model="form.senyera" value="1">
                                <label for="senyera-1">
                                    <span>1</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-2" v-model="form.senyera" value="2">
                                <label for="senyera-2">
                                    <span>2</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-3" v-model="form.senyera" value="3">
                                <label for="senyera-3">
                                    <span>3</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-4" v-model="form.senyera" value="4">
                                <label for="senyera-4">
                                    <span>4</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-5" v-model="form.senyera" value="5">
                                <label for="senyera-5">
                                    <span>5</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-6" v-model="form.senyera" value="6">
                                <label for="senyera-6">
                                    <span>6</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-7" v-model="form.senyera" value="7">
                                <label for="senyera-7">
                                    <span>7</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-8" v-model="form.senyera" value="8">
                                <label for="senyera-8">
                                    <span>8</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-9" v-model="form.senyera" value="9">
                                <label for="senyera-9">
                                    <span>9</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="senyera-10" v-model="form.senyera" value="10">
                                <label for="senyera-10">
                                    <span>10</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-show="currentStep === 4" class="col-md-9 text-center">
                        <img :src="'../img/escut/lineas.jpg'" class="my-5" style="width: 300px;" alt="">
                        <h3 class="my-3 font-weight-bold">LLISTES BLANC-I-VERMELLES</h3>
                        <p class="text-max-800">Colors de la primera equipació del club. S’utilitzaven per remarcar els colors que vestien els jugadors de l’equip.</p>
                        <div class="custom-radios">
                            <div>
                                <input type="radio" id="llistes-1" v-model="form.llistes" value="1">
                                <label for="llistes-1">
                                    <span>1</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-2" v-model="form.llistes" value="2">
                                <label for="llistes-2">
                                    <span>2</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-3" v-model="form.llistes" value="3">
                                <label for="llistes-3">
                                    <span>3</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-4" v-model="form.llistes" value="4">
                                <label for="llistes-4">
                                    <span>4</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-5" v-model="form.llistes" value="5">
                                <label for="llistes-5">
                                    <span>5</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-6" v-model="form.llistes" value="6">
                                <label for="llistes-6">
                                    <span>6</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-7" v-model="form.llistes" value="7">
                                <label for="llistes-7">
                                    <span>7</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-8" v-model="form.llistes" value="8">
                                <label for="llistes-8">
                                    <span>8</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-9" v-model="form.llistes" value="9">
                                <label for="llistes-9">
                                    <span>9</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="llistes-10" v-model="form.llistes" value="10">
                                <label for="llistes-10">
                                    <span>10</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-show="currentStep === 5" class="col-md-9 text-center">
                        <img :src="'../img/escut/rio.jpg'" class="my-5" style="width: 300px;" alt="">
                        <h3 class="my-3 font-weight-bold">AIGÜES</h3>
                        <p class="text-max-800">Les ‘ondes’ representen habitualment cossos d’aigua. A la majoria d’escuts del Girona FC apareixen quatre ondes, que popularment es coneixen com els quatre rius de la ciutat.</p>
                        <div class="custom-radios">
                            <div>
                                <input type="radio" id="aigues-1" v-model="form.aigues" value="1">
                                <label for="aigues-1">
                                    <span>1</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-2" v-model="form.aigues" value="2">
                                <label for="aigues-2">
                                    <span>2</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-3" v-model="form.aigues" value="3">
                                <label for="aigues-3">
                                    <span>3</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-4" v-model="form.aigues" value="4">
                                <label for="aigues-4">
                                    <span>4</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-5" v-model="form.aigues" value="5">
                                <label for="aigues-5">
                                    <span>5</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-6" v-model="form.aigues" value="6">
                                <label for="aigues-6">
                                    <span>6</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-7" v-model="form.aigues" value="7">
                                <label for="aigues-7">
                                    <span>7</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-8" v-model="form.aigues" value="8">
                                <label for="aigues-8">
                                    <span>8</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-9" v-model="form.aigues" value="9">
                                <label for="aigues-9">
                                    <span>9</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="aigues-10" v-model="form.aigues" value="10">
                                <label for="aigues-10">
                                    <span>10</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-show="currentStep === 6" class="col-md-9 text-center">
                        <img v-if="form.bordura == null" :src="'../img/escut/bordura.jpg'" class="my-5" style="width: 300px;" alt="">
                        <img v-if="form.bordura === 'vermell'" :src="'../img/escut/bordura_roja.jpg'" class="my-5" style="width: 300px;" alt="">
                        <img v-if="form.bordura === 'blanc'" :src="'../img/escut/bordura_blanca.jpg'" class="my-5" style="width: 300px;" alt="">
                        <h3 class="my-3 font-weight-bold">BORDURA</h3>
                        <p class="text-max-800">Circumferència en la que es basa l’escut. En un inici era de color blanc però des de principis de segle es fa servir el color vermell com a destacat en la bordura de la circumferència.</p>
                        <div id="select-color">
                            <input type="radio" v-model="form.bordura" id="vermell" value="vermell" style="position: absolute; left: -9999px;" />
                            <label for="vermell">
                                <img :src="'../img/escut/bordura_roja_SMALL.jpg'" class="my-3" style="width: 124px;" alt="">
                            </label>
                            <input type="radio" v-model="form.bordura" id="blanc" value="blanc" style="position: absolute; left: -9999px;" />
                            <label for="blanc">
                                <img :src="'../img/escut/bordura_blanca_SMALL.jpg'" class="my-3" style="width: 124px;" alt="">
                            </label>
                        </div>
                    </div>
                    <div v-show="currentStep === 7" class="col-md-9 text-center">
                        <img :src="'../img/escut/nom.jpg'" class="my-5" style="width: 300px;" alt="">
                        <h3 class="my-3 font-weight-bold">NOM DEL CLUB</h3>
                        <p class="text-max-800">Expressió escrita del nom “GIRONA FUTBOL CLUB” 	que identifica i diferencia l’escut del club respecte als altres.</p>
                        <div class="custom-radios">
                            <div>
                                <input type="radio" id="nom-1" v-model="form.nom" value="1">
                                <label for="nom-1">
                                    <span>1</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-2" v-model="form.nom" value="2">
                                <label for="nom-2">
                                    <span>2</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-3" v-model="form.nom" value="3">
                                <label for="nom-3">
                                    <span>3</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-4" v-model="form.nom" value="4">
                                <label for="nom-4">
                                    <span>4</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-5" v-model="form.nom" value="5">
                                <label for="nom-5">
                                    <span>5</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-6" v-model="form.nom" value="6">
                                <label for="nom-6">
                                    <span>6</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-7" v-model="form.nom" value="7">
                                <label for="nom-7">
                                    <span>7</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-8" v-model="form.nom" value="8">
                                <label for="nom-8">
                                    <span>8</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-9" v-model="form.nom" value="9">
                                <label for="nom-9">
                                    <span>9</span>
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="nom-10" v-model="form.nom" value="10">
                                <label for="nom-10">
                                    <span>10</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-show="currentStep === 8" class="col-md-9 text-center">
                        <h3 class="my-3 font-weight-bold mt-5">Ordena de més a menys important els elements</h3>
                        <p>Ordena de l'1 al 6 els elements segons la teva importància.</p>
                        <div class="row">
                            <div class="col-4 col-md-4 my-4">
                                <img :src="'../img/corona_small.jpg'" class="img-fluid" alt="">
                                <select v-model="form.ordena_corona">
                                    <option value=""></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="3">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                            <div class="col-4 col-md-4 my-4">
                                <img :src="'../img/aigues_small.jpg'" class="img-fluid" alt="">
                                <select v-model="form.ordena_aigues">
                                    <option value=""></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="3">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                            <div class="col-4 col-md-4 my-4">
                                <img :src="'../img/nom_small.jpg'" class="img-fluid" alt="">
                                <select v-model="form.ordena_nom">
                                    <option value=""></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="3">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                            <div class="col-4 col-md-4 mb-4">
                                <img :src="'../img/llistes_small.jpg'" class="img-fluid" alt="">
                                <select v-model="form.ordena_llistes">
                                    <option value=""></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="3">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                            <div class="col-4 col-md-4 mb-4">
                                <img :src="'../img/bordura_small.jpg'" class="img-fluid" alt="">
                                <select v-model="form.ordena_bordura">
                                    <option value=""></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="3">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                            <div class="col-4 col-md-4 mb-4">
                                <img :src="'../img/senyera_small.jpg'" class="img-fluid" alt="">
                                <select v-model="form.ordena_senyera">
                                    <option value=""></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="3">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div v-show="currentStep === 9" class="col-md-9 text-center">
                        <h3 class="my-3 font-weight-bold mt-5">PREGUNTA 1</h3>
                        <textarea name="pregunta1" id="pregunta1" class="form-control mb-3" v-model="form.pregunta1" cols="20" rows="8"></textarea>
                    </div>
                    <div v-show="currentStep === 10" class="col-md-9 text-center">
                        <h3 class="my-3 font-weight-bold mt-5">PREGUNTA 2</h3>
                        <textarea name="pregunta2" id="pregunta2" class="form-control mb-3" v-model="form.pregunta2" cols="20" rows="8"></textarea>
                    </div>
                    <div v-show="currentStep === 11" class="col-md-9 text-center">
                        <h3 class="my-3 font-weight-bold mt-5">DEIXA UN COMENTARI</h3>
                        <textarea name="comentari" id="comentari" class="form-control" v-model="form.comentari" cols="20" rows="8"></textarea>
                        <div class="my-4">
                            <input type="checkbox" id="condicions" v-model="form.condicions" value="condicions">
                            <label for="condicions">He llegit i acepto els <a href="#">termes i condicions</a></label><br>
                            <input type="checkbox" id="politica" v-model="form.politica" value="politica">
                            <label for="politica">He llegit i acepto la <a href="#">política de privacitat</a></label><br>
                        </div>
                    </div>
                    <div v-show="currentStep === 12" class="col-md-9 text-center">
                        <h3 class="my-3 font-weight-bold mt-5">Resum de la teva votació</h3>
                        <p class="text-max-800 font-weight-bold mt-5">Valoració dels elements</p>
                        <ul style="padding: 0; margin-top: 15px; list-style: none;">
                            <li style="margin-bottom: 8px;">Corona <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.corona }}</span></li>
                            <li style="margin-bottom: 8px;">Senyera <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.senyera }}</span></li>
                            <li style="margin-bottom: 8px;">Llistes blanc-i-vermelles <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.llistes }}</span></li>
                            <li style="margin-bottom: 8px;">Aigues <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.aigues }}</span></li>
                            <li style="margin-bottom: 8px;">Bordura <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.bordura ? 'Blanca' : 'Vermella' }}</span></li>
                            <li style="margin-bottom: 8px;">Nom del club <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.nom }}</span></li>
                        </ul>
                        <p class="text-max-800 font-weight-bold mt-5">Posició d'importància dels elements</p>
                        <ul style="padding: 0; margin-top: 15px; list-style: none;">
                            <li style="margin-bottom: 8px;">Corona <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.ordena_corona }}</span></li>
                            <li style="margin-bottom: 8px;">Senyera <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.ordena_senyera }}</span></li>
                            <li style="margin-bottom: 8px;">Llistes blanc-i-vermelles <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.ordena_llistes }}</span></li>
                            <li style="margin-bottom: 8px;">Aigues <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.ordena_aigues }}</span></li>
                            <li style="margin-bottom: 8px;">Bordura <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.ordena_bordura }}</span></li>
                            <li style="margin-bottom: 8px;">Nom del club <span style="background-color: #cd1733; color: #fff; border-radius: 10px; font-weight: bold; padding: 4px 8px; margin-left: 6px;">{{ form.ordena_nom }}</span></li>
                        </ul>
                    </div>
                </div>
                <div class="mt-2 text-center">
                    <button type="submit" style="background-color: rgb(205, 23, 51); border-radius: 10px; color: rgb(255, 255, 255); border: none; text-transform: uppercase; font-weight: bold; text-decoration: none; padding: 4px 35px; margin-top: 25px;" @click="nextStep" v-if="this.currentStep === 1">Comença la consulta</button>
                    <button type="submit" style="background-color: transparent !important; color: #212529; border-radius: 10px; border: 2px solid #EFEFEF; text-transform: uppercase; font-weight: bold; text-decoration: none; padding: 4px 35px; margin-right: 5px;" @click="lastStep" v-if="this.currentStep === 3 || this.currentStep === 4 || this.currentStep === 5 || this.currentStep === 6 || this.currentStep === 7 || this.currentStep === 8 || this.currentStep === 9 || this.currentStep === 10 || this.currentStep === 11 || this.currentStep === 12">Enrere</button>
                    <button type="submit" style="background-color: #cd1733; border-radius: 10px; border: 2px solid #cd1733; color: #fff; text-transform: uppercase; font-weight: bold; text-decoration: none; padding: 4px 35px;" @click="nextStep" v-if="this.currentStep === 2 || this.currentStep === 3 || this.currentStep === 4 || this.currentStep === 5 || this.currentStep === 6 || this.currentStep === 7 || this.currentStep === 8 || this.currentStep === 9 || this.currentStep === 10 || this.currentStep === 11">Següent</button>
                    <button type="submit" style="background-color: rgb(205, 23, 51); border-radius: 10px; color: rgb(255, 255, 255); border: none; text-transform: uppercase; font-weight: bold; text-decoration: none; padding: 4px 35px;" @click="submitForm" v-if="this.currentStep === 12">Finalitzar</button>
                </div>
            </div>
            <div v-else>
                <div class="row justify-content-md-center mt-5">
                    <div class="col-md-9 text-center">
                        <h3 class="my-3 font-weight-bold">Gràcies per la teva votació!</h3>
                        <img :src="'../img/escut/gracias_ 536x354.jpg'" class="img-fluid my-3" alt="">
                        <p class="text-max-800">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
                        <p class="text-max-800 mt-4">Compartir la meva votació</p>
                        <ul class="thanks-social">
                            <li><a href="https://twitter.com/intent/tweet?text=Ja%20he%20participat%20a%20la%20consulta%20per%20al%20nou%20escut%20del%20Girona%20FC!%20Sois,%20participeu-hi%20ara:%20&url=https://escut.gironafc.cat"><i class="fab fa-twitter"></i></a></li>
                            <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                            <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="https://api.whatsapp.com/send?text=Ja%20he%20participat%20a%20la%20consulta%20per%20al%20nou%20escut%20del%20Girona%20FC!%20Sois,%20participeu-hi%20ara:%20https://escut.gironafc.cat"><i class="fab fa-whatsapp"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {
            steps: [
                {
                    id: 1,
                    title: "Corona",
                },
                {
                    id: 2,
                    title: "Senyera",
                },
                {
                    id: 3,
                    title: "Llistes",
                },
                {
                    id: 4,
                    title: "Aigues",
                },
                {
                    id: 5,
                    title: "Bordura",
                },
                {
                    id: 6,
                    title: "Nom",
                },
                {
                    id: 7,
                    title: "Comentari",
                },
                {
                    id: 8,
                    title: "Gracies",
                },
                {
                    id: 9,
                    title: "Gracies",
                },
                {
                    id: 10,
                    title: "Gracies",
                },
                {
                    id: 11,
                    title: "Gracies",
                },
                {
                    id: 12,
                    title: "Gracies",
                }
            ],
            errors: [],
            currentStep: 1,
            completed: false,
            form: {
                corona: null,
                senyera: null,
                llistes: null,
                aigues: null,
                bordura: null,
                nom: null,
                comentari: null,
                condicions: false,
                politica: false,
                pregunta1: null,
                pregunta2: null,
                ordena_corona: null,
                ordena_aigues: null,
                ordena_nom: null,
                ordena_bordura: null,
                ordena_llistes: null,
                ordena_senyera: null
            }
        }
    },
    methods: {
        nextStep: function (e) {

            this.errors = [];



            if(this.currentStep === 2) {
                if (this.form.corona == null) {
                    this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
                    return false;
                }
            }

            if(this.currentStep === 3) {
                if (this.form.senyera == null) {
                    this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
                    return false;
                }
            }

            if(this.currentStep === 4) {
                if (this.form.llistes == null) {
                    this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
                    return false;
                }
            }

            if(this.currentStep === 5) {
                if (this.form.aigues == null) {
                    this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
                    return false;
                }
            }

            if(this.currentStep === 6) {
                if (this.form.bordura == null) {
                    this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
                    return false;
                }
            }

            if(this.currentStep === 7) {
                if (this.form.nom == null) {
                    this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
                    return false;
                }
            }

            if(this.currentStep === 8) {
                if (this.form.ordena_corona == null || this.form.ordena_aigues == null || this.form.ordena_nom == null || this.form.ordena_bordura == null || this.form.ordena_llistes == null || this.form.ordena_senyera == null) {
                    this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
                    return false;
                }
            }

            if(this.currentStep === 11) {
                if (this.form.condicions === false || this.form.politica === false ) {
                    this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
                    return false;
                }
            }

            this.currentStep++;

            e.preventDefault();
        },
        lastStep() {
            this.currentStep--;
        },
        submitForm(){
            console.log(this.form)
            this.completed = true;
        }
    }
}
</script>
